<div>
    <info></info>
    <tag></tag>
    <paths></paths>
    <security></security>
</div>